// ═══════════════════════════════════════════════════════════════════════════════
// Family member birthday: optional full YYYY-MM-DD or month-day only as --MM-DD
// ═══════════════════════════════════════════════════════════════════════════════
import { DATE_REGEX } from '../constants/index.js';
const PARTIAL_REGEX = /^--(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
const isCalendarValid = (year, month, day) => {
    const probe = new Date(year, month - 1, day);
    return (probe.getFullYear() === year &&
        probe.getMonth() === month - 1 &&
        probe.getDate() === day);
};
/**
 * True if empty, valid YYYY-MM-DD, or valid --MM-DD (month-day without year).
 */
export const isValidFamilyMemberBirthday = (raw) => {
    const s = raw.trim();
    if (s === '') {
        return true;
    }
    if (DATE_REGEX.test(s)) {
        const y = Number(s.slice(0, 4));
        const m = Number(s.slice(5, 7));
        const d = Number(s.slice(8, 10));
        return isCalendarValid(y, m, d);
    }
    if (PARTIAL_REGEX.test(s)) {
        const m = Number(s.slice(2, 4));
        const d = Number(s.slice(5, 7));
        return isCalendarValid(2000, m, d);
    }
    return false;
};
export const isFullFamilyMemberBirthday = (raw) => {
    const s = raw.trim();
    return DATE_REGEX.test(s) && isValidFamilyMemberBirthday(s);
};
export const isPartialFamilyMemberBirthday = (raw) => {
    const s = raw.trim();
    return PARTIAL_REGEX.test(s) && isValidFamilyMemberBirthday(s);
};
/** Parse storage string into UI parts (month/day zero-padded). */
export const parseFamilyMemberBirthdayParts = (raw) => {
    const s = raw.trim();
    if (!s) {
        return { year: '', month: '', day: '' };
    }
    if (s.startsWith('--') && s.length >= 7) {
        return { year: '', month: s.slice(2, 4), day: s.slice(5, 7) };
    }
    const parts = s.split('-');
    if (parts.length === 3) {
        return { year: parts[0] ?? '', month: parts[1] ?? '', day: parts[2] ?? '' };
    }
    return { year: '', month: '', day: '' };
};
//# sourceMappingURL=familyMemberBirthday.js.map